import React from 'react';
import { Monitor, PenLine, Code2, Rocket, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function WebsiteCard() {
  const {
    t
  } = useLanguage();
  const process = [{
    icon: PenLine,
    label: t.web_process1
  }, {
    icon: Code2,
    label: t.web_process2
  }, {
    icon: Rocket,
    label: t.web_process3
  }];
  const results = [{
    num: t.web_result1_num,
    label: t.web_result1_label,
    color: 'text-cyan-400'
  }, {
    num: t.web_result2_num,
    label: t.web_result2_label,
    color: 'text-yellow-400'
  }, {
    num: t.web_result3_num,
    label: t.web_result3_label,
    color: 'text-purple-400'
  }];
  const pills = [t.web_pill1, t.web_pill2, t.web_pill3];
  return <div className="bg-kinetic-card border border-white/[0.08] rounded-xl p-5 sm:p-8 hover:border-cyan-400/40 transition-colors duration-300 overflow-hidden" data-id="element-243" data-mp="hn4ro4jkoxw5">
      <Monitor className="w-8 h-8 sm:w-10 sm:h-10 text-cyan-400" data-id="element-244" data-mp="2711dj9dfb8ar" />
      <span className="block text-xs text-cyan-400 uppercase tracking-wide mt-5 sm:mt-6" data-id="element-245" data-mp="2c1fgid063s1x">
        {t.web_tag}
      </span>
      <h3 className="text-xl sm:text-2xl font-bold text-white mt-2" data-id="element-246" data-mp="o09kqjampi5y">{t.web_title}</h3>
      <p className="text-white/60 text-sm mt-3 leading-relaxed" data-id="element-247" data-mp="j39g8ctfgngy">{t.web_description}</p>

      {/* Visual process strip */}
      <div className="flex items-center gap-1 sm:gap-2 mt-5 sm:mt-6" data-id="element-248" data-mp="stb3j2dyi1ut">
        {process.map((step, index) => <React.Fragment key={step.label} data-id="element-249" data-mp="53gqajpq6ba1" data-mpi={index}>
            <div className="bg-black/40 border border-white/10 rounded-lg p-2 sm:p-3 text-center flex-1 min-w-0" data-id="element-250" data-mp="54a1pxzmpoyi">
              <step.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-cyan-400 mx-auto mb-1" data-id="element-251" data-mp="6hxq5lpmcdy" />
              <span className="text-[10px] sm:text-xs text-white/60 leading-tight block" data-id="element-252" data-mp="e5q17aowo6ny">
                {step.label}
              </span>
            </div>
            {index < process.length - 1 && <span className="text-cyan-400/40 text-sm sm:text-lg shrink-0" data-id="element-253" data-mp="1phqvf54jgnb3">→</span>}
          </React.Fragment>)}
      </div>

      {/* Results bar */}
      <div className="grid grid-cols-3 bg-black/40 rounded-xl p-3 sm:p-4 mt-5 sm:mt-6" data-id="element-254" data-mp="i61a4ai14ci0">
        {results.map((result, index) => <div key={result.label} className={`text-center px-1 min-w-0 ${index < results.length - 1 ? 'border-r border-white/[0.08]' : ''}`} data-id="element-255" data-mp="n8a49a6n1klp" data-mpi={index}>
            <div className={`text-lg sm:text-2xl font-black ${result.color}`} data-id="element-256" data-mp="w6byn6vv9f00">{result.num}</div>
            <div className="text-[10px] sm:text-xs text-white/40 mt-1 leading-tight" data-id="element-257" data-mp="3vnacukq9y0j1">
              {result.label}
            </div>
          </div>)}
      </div>

      {/* Honest promise box */}
      <div className="flex items-start gap-3 bg-cyan-950/30 border border-cyan-500/20 rounded-lg p-3 sm:p-4 mt-5 sm:mt-6" data-id="element-258" data-mp="8fq3uhavhr7y">
        <ShieldCheck className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-259" data-mp="da2p8wvwtcmc" />
        <p className="text-white/70 text-sm" data-id="element-260" data-mp="3bxgo6fiuw1j1">{t.web_promise}</p>
      </div>

      <span className="block text-xs text-white/30 uppercase tracking-widest mt-5 sm:mt-6" data-id="element-261" data-mp="3gwb7dikqjs3o">
        {t.web_levels_label}
      </span>
      <div className="flex gap-2 flex-wrap mt-3" data-id="element-262" data-mp="39csf0lplqmif">
        {pills.map(pill => <span key={pill} className="border border-white/15 rounded-full px-3 py-1 text-xs text-white/40" data-id="element-263" data-mp="34fs5u1xgh3n3">
            {pill}
          </span>)}
      </div>
      <p className="text-xs text-white/25 mt-2" data-id="element-264" data-mp="2vd0wq8s1yjym">{t.web_pricing_note}</p>

      <a href="#consulta" className="inline-block text-cyan-400 text-sm mt-5 sm:mt-6 hover:text-cyan-300 transition-colors" data-id="element-265" data-mp="2qezbbh75m8jz">
        {t.web_cta}
      </a>
    </div>;
}